import styled from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';

export const PartnerCardContainer = styled.div`
  flex: 0 1 350px;
  height: 200px;
  margin: ${getDimension('size3')};
`;
